import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexRowCenter,
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';

interface Props {
  price: number | string;
  priceWithoutVat?: number | string;
  currency: string;
}

function PriceInfo({ price, priceWithoutVat, currency }: Props) {
  return (
    <PricesWrapper>
      <Wrapper>
        <Price>{`${price} ${currency}`}</Price>
        <SecondaryText>
          {`${priceWithoutVat} ${currency}`} {__('bez DPH')}
        </SecondaryText>
      </Wrapper>
    </PricesWrapper>
  );
}

const PricesWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
`;

const Wrapper = styled(FlexCol)`
  justify-content: space-between;
`;

const Price = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(24)};
  line-height: ${rem(28)};
  font-weight: bold;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: ${rem(4)};
  white-space: nowrap;
`;

const SecondaryText = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  line-height: ${rem(18)};
  color: ${({ theme }) => theme.colors.black};
`;

export { PriceInfo };
